import { render, staticRenderFns } from "./UpdateApproveAccount.vue?vue&type=template&id=8d47c918"
import script from "./UpdateApproveAccount.vue?vue&type=script&lang=js"
export * from "./UpdateApproveAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports